const D = {
	LANG: 'en',
	LANGS: ['en'],
	DEFAULT_LANG: 'en',
	DEV: '',
	ID: 0,
	UPL: '',
	VUPL: '',
	PRICE: {},
	FB_APP_ID: '',
	URL: '',
	SESSION_DISCOUNT: '',
	SESSION_INVITE_EMAIL: '',
	HAS_TEAM: false,
	EVENT: {},
	MIN_AFFILIATE: 1000,
	AFFILIATE_ENABLED: false,
	AFFILIATE_DISCOUNT: false,
	BRAINTREE_3DS_ENABLED: false,
	DS: '',
	QUOTES: [],
	CASE_STUDIES: [],
	OS: '',
	BROWSER: '',
	SESSION_DISCOUNT_AMOUNT: '',
	FOOTER: {
		links: [],
		info: {
			title: '',
			text: ''
		},
		contacts: {
			href: '',
			text: ''
		},
		copyright: {
			text: ''
		},
		liaa: ''
	},
	OG: {},
	APP_WEBVIEW: false,
	me: {
		id: 0,
		name: '',
		hasAdminAccess: false
	},
	v: 0,

	countries: {
		lv: {
			AF: "Afganistāna",
			AL: "Albānija",
			DZ: "Alžīrija",
			US: "Amerikas Savienotās Valstis",
			AD: "Andora",
			AI: "Angilja",
			AO: "Angola",
			AQ: "Antarktika",
			AG: "Antigva un Barbuda",
			AE: "Apvienotie Arābu Emirāti",
			AR: "Argentīna",
			AM: "Armēnija",
			AW: "Aruba",
			UM: "ASV Mazās Aizjūras salas",
			AS: "ASV Samoa",
			VI: "ASV Virdžīnas",
			AU: "Austrālija",
			AT: "Austrija",
			TL: "Austrumtimora",
			AZ: "Azerbaidžāna",
			BS: "Bahamu salas",
			BH: "Bahreina",
			BY: "Baltkrievija",
			BD: "Bangladeša",
			BB: "Barbadosa",
			BZ: "Beliza",
			BE: "Beļģija",
			BJ: "Benina",
			BM: "Bermudu salas",
			BO: "Bolīvija",
			BA: "Bosnija un Hercegovina",
			BW: "Botsvāna",
			BR: "Brazīlija",
			VG: "Britu Virdžīnas",
			BN: "Bruneja",
			BG: "Bulgārija",
			BF: "Burkinafaso",
			BI: "Burundija",
			BT: "Butāna",
			CF: "Centrālāfrikas Republika",
			TD: "Čada",
			CZ: "Čehija",
			CL: "Čīle",
			DK: "Dānija",
			AC: "Debesbraukšanas sala",
			ZA: "Dienvidāfrikas Republika",
			GS: "Dienviddžordžija un Dienvidsendviču salas",
			KR: "Dienvidkoreja",
			SS: "Dienvidsudāna",
			DG: "Djego Garsijas atols",
			DM: "Dominika",
			DO: "Dominikāna",
			JE: "Džērsija",
			DJ: "Džibutija",
			EG: "Ēģipte",
			EC: "Ekvadora",
			GQ: "Ekvatoriālā Gvineja",
			ER: "Eritreja",
			ET: "Etiopija",
			FO: "Fēru salas",
			FJ: "Fidži",
			PH: "Filipīnas",
			FK: "Folklenda salas",
			FR: "Francija",
			TF: "Francijas Dienvidjūru teritorija",
			GF: "Francijas Gviāna",
			PF: "Francijas Polinēzija",
			GA: "Gabona",
			GY: "Gajāna",
			GM: "Gambija",
			GH: "Gana",
			GG: "Gērnsija",
			GI: "Gibraltārs",
			GD: "Grenāda",
			GL: "Grenlande",
			GR: "Grieķija",
			GE: "Gruzija",
			GU: "Guama",
			GP: "Gvadelupa",
			GT: "Gvatemala",
			GN: "Gvineja",
			GW: "Gvineja-Bisava",
			HT: "Haiti",
			HN: "Hondurasa",
			HR: "Horvātija",
			EE: "Igaunija",
			IN: "Indija",
			ID: "Indonēzija",
			IQ: "Irāka",
			IR: "Irāna",
			IE: "Īrija",
			IS: "Islande",
			IT: "Itālija",
			IL: "Izraēla",
			JM: "Jamaika",
			JP: "Japāna",
			NC: "Jaunkaledonija",
			NZ: "Jaunzēlande",
			YE: "Jemena",
			JO: "Jordānija",
			CV: "Kaboverde",
			KY: "Kaimanu salas",
			KH: "Kambodža",
			CM: "Kamerūna",
			CA: "Kanāda",
			IC: "Kanāriju salas",
			QA: "Katara",
			KZ: "Kazahstāna",
			KE: "Kenija",
			CY: "Kipra",
			CW: "Kirasao",
			KG: "Kirgizstāna",
			KI: "Kiribati",
			CC: "Kokosu (Kīlinga) salas",
			CO: "Kolumbija",
			KM: "Komoru salas",
			CG: "Kongo (Brazavila)",
			CD: "Kongo (Kinšasa)",
			XK: "Kosova",
			CR: "Kostarika",
			CI: "Kotdivuāra",
			RU: "Krievija",
			CU: "Kuba",
			CK: "Kuka salas",
			KW: "Kuveita",
			CN: "Ķīna",
			HK: "Ķīnas īpašās pārvaldes apgabals Honkonga",
			MO: "Ķīnas īpašās pārvaldes apgabals Makao",
			LA: "Laosa",
			LV: "Latvija",
			LS: "Lesoto",
			LB: "Libāna",
			LR: "Libērija",
			LY: "Lībija",
			GB: "Lielbritānija",
			LT: "Lietuva",
			LI: "Lihtenšteina",
			LU: "Luksemburga",
			MG: "Madagaskara",
			YT: "Majota",
			MK: "Maķedonija",
			MY: "Malaizija",
			MW: "Malāvija",
			MV: "Maldīvija",
			ML: "Mali",
			MT: "Malta",
			MA: "Maroka",
			MH: "Māršala salas",
			MQ: "Martinika",
			MU: "Maurīcija",
			MR: "Mauritānija",
			MX: "Meksika",
			ME: "Melnkalne",
			IM: "Mena",
			FM: "Mikronēzija",
			MM: "Mjanma (Birma)",
			MD: "Moldova",
			MC: "Monako",
			MN: "Mongolija",
			MS: "Montserrata",
			MZ: "Mozambika",
			NA: "Namībija",
			NR: "Nauru",
			NP: "Nepāla",
			NL: "Nīderlande",
			BQ: "Nīderlandes Karību salas",
			NE: "Nigēra",
			NG: "Nigērija",
			NI: "Nikaragva",
			NU: "Niue",
			NF: "Norfolkas sala",
			NO: "Norvēģija",
			AX: "Olandes salas",
			OM: "Omāna",
			PK: "Pakistāna",
			PW: "Palau",
			PS: "Palestīna",
			PA: "Panama",
			PG: "Papua-Jaungvineja",
			PY: "Paragvaja",
			PE: "Peru",
			PN: "Pitkērnas salas",
			PL: "Polija",
			PT: "Portugāle",
			PR: "Puertoriko",
			RE: "Reinjona",
			EH: "Rietumsahāra",
			RW: "Ruanda",
			RO: "Rumānija",
			SV: "Salvadora",
			WS: "Samoa",
			SM: "Sanmarīno",
			ST: "Santome un Prinsipi",
			SA: "Saūda Arābija",
			SC: "Seišelu salas",
			BL: "Senbartelmī",
			SN: "Senegāla",
			MF: "Senmartēna",
			PM: "Senpjēra un Mikelona",
			KN: "Sentkitsa un Nevisa",
			LC: "Sentlūsija",
			VC: "Sentvinsenta un Grenadīnas",
			RS: "Serbija",
			EA: "Seūta un Melilja",
			SG: "Singapūra",
			SX: "Sintmārtena",
			SY: "Sīrija",
			SL: "Sjerraleone",
			SK: "Slovākija",
			SI: "Slovēnija",
			SO: "Somālija",
			FI: "Somija",
			ES: "Spānija",
			SD: "Sudāna",
			SR: "Surinama",
			SH: "Sv.Helēnas sala",
			SJ: "Svalbāra un Jana Majena sala",
			SZ: "Svazilenda",
			LK: "Šrilanka",
			CH: "Šveice",
			TJ: "Tadžikistāna",
			TW: "Taivāna",
			TH: "Taizeme",
			TZ: "Tanzānija",
			TC: "Tērksas un Kaikosas salas",
			TG: "Togo",
			TK: "Tokelau",
			TO: "Tonga",
			TT: "Trinidāda un Tobāgo",
			TA: "Tristana da Kuņas salas",
			TN: "Tunisija",
			TR: "Turcija",
			TM: "Turkmenistāna",
			TV: "Tuvalu",
			UG: "Uganda",
			UA: "Ukraina",
			HU: "Ungārija",
			UY: "Urugvaja",
			UZ: "Uzbekistāna",
			DE: "Vācija",
			VU: "Vanuatu",
			VA: "Vatikāns",
			VE: "Venecuēla",
			VN: "Vjetnama",
			WF: "Volisa un Futunas salas",
			SB: "Zālamana salas",
			ZM: "Zambija",
			KP: "Ziemeļkoreja",
			MP: "Ziemeļu Marianas salas",
			CX: "Ziemsvētku sala",
			ZW: "Zimbabve",
			SE: "Zviedrija"
		},
		en: {
			AF: "Afghanistan",
			AX: "Åland Islands",
			AL: "Albania",
			DZ: "Algeria",
			AS: "American Samoa",
			AD: "Andorra",
			AO: "Angola",
			AI: "Anguilla",
			AQ: "Antarctica",
			AG: "Antigua & Barbuda",
			AR: "Argentina",
			AM: "Armenia",
			AW: "Aruba",
			AC: "Ascension Island",
			AU: "Australia",
			AT: "Austria",
			AZ: "Azerbaijan",
			BS: "Bahamas",
			BH: "Bahrain",
			BD: "Bangladesh",
			BB: "Barbados",
			BY: "Belarus",
			BE: "Belgium",
			BZ: "Belize",
			BJ: "Benin",
			BM: "Bermuda",
			BT: "Bhutan",
			BO: "Bolivia",
			BA: "Bosnia & Herzegovina",
			BW: "Botswana",
			BR: "Brazil",
			VG: "British Virgin Islands",
			BN: "Brunei",
			BG: "Bulgaria",
			BF: "Burkina Faso",
			BI: "Burundi",
			KH: "Cambodia",
			CM: "Cameroon",
			CA: "Canada",
			IC: "Canary Islands",
			CV: "Cape Verde",
			BQ: "Caribbean Netherlands",
			KY: "Cayman Islands",
			CF: "Central African Republic",
			EA: "Ceuta & Melilla",
			TD: "Chad",
			CL: "Chile",
			CN: "China",
			CX: "Christmas Island",
			CC: "Cocos (Keeling) Islands",
			CO: "Colombia",
			KM: "Comoros",
			CG: "Congo - Brazzaville",
			CD: "Congo - Kinshasa",
			CK: "Cook Islands",
			CR: "Costa Rica",
			CI: "Côte d’Ivoire",
			HR: "Croatia",
			CU: "Cuba",
			CW: "Curaçao",
			CY: "Cyprus",
			CZ: "Czechia",
			DK: "Denmark",
			DG: "Diego Garcia",
			DJ: "Djibouti",
			DM: "Dominica",
			DO: "Dominican Republic",
			EC: "Ecuador",
			EG: "Egypt",
			SV: "El Salvador",
			GQ: "Equatorial Guinea",
			ER: "Eritrea",
			EE: "Estonia",
			ET: "Ethiopia",
			FK: "Falkland Islands",
			FO: "Faroe Islands",
			FJ: "Fiji",
			FI: "Finland",
			FR: "France",
			GF: "French Guiana",
			PF: "French Polynesia",
			TF: "French Southern Territories",
			GA: "Gabon",
			GM: "Gambia",
			GE: "Georgia",
			DE: "Germany",
			GH: "Ghana",
			GI: "Gibraltar",
			GR: "Greece",
			GL: "Greenland",
			GD: "Grenada",
			GP: "Guadeloupe",
			GU: "Guam",
			GT: "Guatemala",
			GG: "Guernsey",
			GN: "Guinea",
			GW: "Guinea-Bissau",
			GY: "Guyana",
			HT: "Haiti",
			HN: "Honduras",
			HK: "Hong Kong SAR China",
			HU: "Hungary",
			IS: "Iceland",
			IN: "India",
			ID: "Indonesia",
			IR: "Iran",
			IQ: "Iraq",
			IE: "Ireland",
			IM: "Isle of Man",
			IL: "Israel",
			IT: "Italy",
			JM: "Jamaica",
			JP: "Japan",
			JE: "Jersey",
			JO: "Jordan",
			KZ: "Kazakhstan",
			KE: "Kenya",
			KI: "Kiribati",
			XK: "Kosovo",
			KW: "Kuwait",
			KG: "Kyrgyzstan",
			LA: "Laos",
			LV: "Latvia",
			LB: "Lebanon",
			LS: "Lesotho",
			LR: "Liberia",
			LY: "Libya",
			LI: "Liechtenstein",
			LT: "Lithuania",
			LU: "Luxembourg",
			MO: "Macau SAR China",
			MK: "Macedonia",
			MG: "Madagascar",
			MW: "Malawi",
			MY: "Malaysia",
			MV: "Maldives",
			ML: "Mali",
			MT: "Malta",
			MH: "Marshall Islands",
			MQ: "Martinique",
			MR: "Mauritania",
			MU: "Mauritius",
			YT: "Mayotte",
			MX: "Mexico",
			FM: "Micronesia",
			MD: "Moldova",
			MC: "Monaco",
			MN: "Mongolia",
			ME: "Montenegro",
			MS: "Montserrat",
			MA: "Morocco",
			MZ: "Mozambique",
			MM: "Myanmar (Burma)",
			NA: "Namibia",
			NR: "Nauru",
			NP: "Nepal",
			NL: "Netherlands",
			NC: "New Caledonia",
			NZ: "New Zealand",
			NI: "Nicaragua",
			NE: "Niger",
			NG: "Nigeria",
			NU: "Niue",
			NF: "Norfolk Island",
			KP: "North Korea",
			MP: "Northern Mariana Islands",
			NO: "Norway",
			OM: "Oman",
			PK: "Pakistan",
			PW: "Palau",
			PS: "Palestinian Territories",
			PA: "Panama",
			PG: "Papua New Guinea",
			PY: "Paraguay",
			PE: "Peru",
			PH: "Philippines",
			PN: "Pitcairn Islands",
			PL: "Poland",
			PT: "Portugal",
			PR: "Puerto Rico",
			QA: "Qatar",
			RE: "Réunion",
			RO: "Romania",
			RU: "Russia",
			RW: "Rwanda",
			WS: "Samoa",
			SM: "San Marino",
			ST: "São Tomé & Príncipe",
			SA: "Saudi Arabia",
			SN: "Senegal",
			RS: "Serbia",
			SC: "Seychelles",
			SL: "Sierra Leone",
			SG: "Singapore",
			SX: "Sint Maarten",
			SK: "Slovakia",
			SI: "Slovenia",
			SB: "Solomon Islands",
			SO: "Somalia",
			ZA: "South Africa",
			GS: "South Georgia & South Sandwich Islands",
			KR: "South Korea",
			SS: "South Sudan",
			ES: "Spain",
			LK: "Sri Lanka",
			BL: "St. Barthélemy",
			SH: "St. Helena",
			KN: "St. Kitts & Nevis",
			LC: "St. Lucia",
			MF: "St. Martin",
			PM: "St. Pierre & Miquelon",
			VC: "St. Vincent & Grenadines",
			SD: "Sudan",
			SR: "Suriname",
			SJ: "Svalbard & Jan Mayen",
			SZ: "Swaziland",
			SE: "Sweden",
			CH: "Switzerland",
			SY: "Syria",
			TW: "Taiwan",
			TJ: "Tajikistan",
			TZ: "Tanzania",
			TH: "Thailand",
			TL: "Timor-Leste",
			TG: "Togo",
			TK: "Tokelau",
			TO: "Tonga",
			TT: "Trinidad & Tobago",
			TA: "Tristan da Cunha",
			TN: "Tunisia",
			TR: "Turkey",
			TM: "Turkmenistan",
			TC: "Turks & Caicos Islands",
			TV: "Tuvalu",
			UM: "U.S. Outlying Islands",
			VI: "U.S. Virgin Islands",
			UG: "Uganda",
			UA: "Ukraine",
			AE: "United Arab Emirates",
			GB: "United Kingdom",
			US: "United States",
			UY: "Uruguay",
			UZ: "Uzbekistan",
			VU: "Vanuatu",
			VA: "Vatican City",
			VE: "Venezuela",
			VN: "Vietnam",
			WF: "Wallis & Futuna",
			EH: "Western Sahara",
			YE: "Yemen",
			ZM: "Zambia",
			ZW: "Zimbabwe"
		},
		et: {
			"AF": "Afganistan",
			"AL": "Albaania",
			"DZ": "Alžeeria",
			"US": "Ameerika Ühendriigid",
			"AD": "Andorra",
			"AO": "Angola",
			"AG": "Antigua ja Barbuda",
			"AE": "Araabia Ühendemiraadid",
			"AR": "Argentina",
			"AM": "Armeenia",
			"AU": "Austraalia",
			"AT": "Austria",
			"AZ": "Aserbaidžaan",
			"BS": "Bahama",
			"BH": "Bahrein",
			"BD": "Bangladesh",
			"BB": "Barbados",
			"PW": "Belau",
			"BE": "Belgia",
			"BZ": "Belize",
			"BJ": "Benin",
			"BT": "Bhutan",
			"MM": "Birma",
			"BO": "Boliivia",
			"BA": "Bosnia ja Hertsegoviina",
			"BW": "Botswana",
			"BR": "Brasiilia",
			"BN": "Brunei",
			"BG": "Bulgaaria",
			"BF": "Burkina Faso",
			"BI": "Burundi",
			"CO": "Colombia",
			"CR": "Costa Rica",
			"DJ": "Djibouti",
			"DM": "Dominica",
			"DO": "Dominikaani Vabariik",
			"EC": "Ecuador",
			"EE": "Eesti",
			"EG": "Egiptus",
			"GQ": "Ekvatoriaal-Guinea",
			"SV": "El Salvador",
			"CI": "Elevandiluurannik",
			"ER": "Eritrea",
			"ET": "Etioopia",
			"FJ": "Fidži",
			"GA": "Gabon",
			"GM": "Gambia",
			"GH": "Ghana",
			"GD": "Grenada",
			"GE": "Gruusia",
			"GT": "Guatemala",
			"GN": "Guinea",
			"GW": "Guinea-Bissau",
			"GY": "Guyana",
			"PH": "Filipiinid",
			"HT": "Haiti",
			"CN": "Hiina",
			"ES": "Hispaania",
			"NL": "Holland",
			"HN": "Honduras",
			"HR": "Horvaatia",
			"IE": "Iirimaa",
			"IL": "Iisrael",
			"TL": "Ida-Timor",
			"IN": "India",
			"ID": "Indoneesia",
			"IS": "Island",
			"IQ": "Iraak",
			"IR": "Iraan",
			"IT": "Itaalia",
			"JP": "Jaapan",
			"JM": "Jamaica",
			"YE": "Jeemen",
			"JO": "Jordaania",
			"KH": "Kambodža",
			"CM": "Kamerun",
			"CA": "Kanada",
			"KZ": "Kasahstan",
			"QA": "Katar",
			"KE": "Keenia",
			"CF": "Kesk-Aafrika Vabariik",
			"KI": "Kiribati",
			"KM": "Komoorid",
			"CD": "Kongo Demokraatlik Vabariik",
			"CG": "Kongo Vabariik",
			"GR": "Kreeka",
			"CU": "Kuuba",
			"KW": "Kuveit",
			"CY": "Küpros",
			"KG": "Kõrgõzstan",
			"LA": "Laos",
			"LT": "Leedu",
			"LS": "Lesotho",
			"LB": "Liibanon",
			"LR": "Libeeria",
			"LI": "Liechtenstein",
			"LY": "Liibüa",
			"LU": "Luksemburg",
			"ZA": "Lõuna-Aafrika Vabariik",
			"KR": "Lõuna-Korea",
			"SS": "Lõuna-Sudaan",
			"LV": "Läti",
			"MG": "Madagaskar",
			"MY": "Malaisia",
			"MW": "Malawi",
			"MV": "Maldiivid",
			"ML": "Mali",
			"MT": "Malta",
			"MA": "Maroko",
			"MH": "Marshalli Saared",
			"MR": "Mauritaania",
			"MU": "Mauritius",
			"MX": "Mehhiko",
			"FM": "Mikroneesia Liiduriigid",
			"MD": "Moldova",
			"MC": "Monaco",
			"MN": "Mongoolia",
			"ME": "Montenegro",
			"MZ": "Mosambiik",
			"NA": "Namiibia",
			"NR": "Nauru",
			"NP": "Nepal",
			"NI": "Nicaragua",
			"NG": "Nigeeria",
			"NE": "Niger",
			"NO": "Norra",
			"OM": "Omaan",
			"PG": "Paapua Uus-Guinea",
			"PK": "Pakistan",
			"PA": "Panama",
			"PY": "Paraguay",
			"PE": "Peruu",
			"PL": "Poola",
			"PT": "Portugal",
			"FR": "Prantsusmaa",
			"KP": "Põhja-Korea",
			"MK": "Põhja-Makedoonia",
			"CV": "Roheneemesaared",
			"SE": "Rootsi",
			"RO": "Rumeenia",
			"RW": "Rwanda",
			"SB": "Saalomoni Saared",
			"KN": "Saint Kitts ja Nevis",
			"LC": "Saint Lucia",
			"VC": "Saint Vincent ja Grenadiinid",
			"DE": "Saksamaa",
			"ZM": "Sambia",
			"WS": "Samoa",
			"SM": "San Marino",
			"ST": "São Tomé ja Príncipe",
			"SA": "Saudi Araabia",
			"SC": "Seišellid",
			"SN": "Senegal",
			"RS": "Serbia",
			"SL": "Sierra Leone",
			"SG": "Singapur",
			"SK": "Slovakkia",
			"SI": "Sloveenia",
			"SO": "Somaalia",
			"FI": "Soome",
			"LK": "Sri Lanka",
			"SD": "Sudaan",
			"SR": "Suriname",
			"GB": "Suurbritannia",
			"SZ": "Svaasimaa",
			"SY": "Süüria",
			"CH": "Šveits",
			"ZW": "Zimbabwe",
			"DK": "Taani",
			"TJ": "Tadžikistan",
			"TH": "Tai",
			"TZ": "Tansaania",
			"TG": "Togo",
			"TO": "Tonga",
			"TT": "Trinidad ja Tobago",
			"TD": "Tšaad",
			"CZ": "Tšehhi",
			"CL": "Tšiili",
			"TN": "Tuneesia",
			"TR": "Türgi",
			"TM": "Türkmenistan",
			"TV": "Tuvalu",
			"UG": "Uganda",
			"UA": "Ukraina",
			"HU": "Ungari",
			"UY": "Uruguay",
			"UZ": "Usbekistan",
			"NZ": "Uus-Meremaa",
			"BY": "Valgevene",
			"VU": "Vanuatu",
			"RU": "Venemaa",
			"VE": "Venezuela",
			"VN": "Vietnam"
		},
		lt: {
			"AF": "Afganistanas",
			"AL": "Albanija",
			"DZ": "Alžyras",
			"AD": "Andora",
			"AO": "Angola",
			"AG": "Antigva ir Barbuda",
			"AR": "Argentina",
			"AM": "Armėnija",
			"AU": "Australija",
			"AT": "Austrija",
			"AZ": "Azerbaidžanas",
			"BS": "Bahamos",
			"BH": "Bahreinas",
			"BY": "Baltarusija",
			"BD": "Bangladešas",
			"BB": "Barbadosas",
			"BE": "Belgija",
			"BZ": "Belizas",
			"BJ": "Beninas",
			"BT": "Butanas",
			"BO": "Bolivija",
			"BA": "Bosnija ir Hercegovina",
			"BW": "Botsvana",
			"BR": "Brazilija",
			"BN": "Brunėjus",
			"BG": "Bulgarija",
			"BF": "Burkina Faso",
			"BI": "Burundis",
			"CF": "Centrinės Afrikos Respublika",
			"TD": "Čadas",
			"CL": "Čilė",
			"CZ": "Čekija",
			"DK": "Danija",
			"CI": "Dramblio Kaulo Krantas",
			"DM": "Dominika",
			"DO": "Dominikos Respublika",
			"DJ": "Džibutis",
			"EG": "Egiptas",
			"EC": "Ekvadoras",
			"ER": "Eritrėja",
			"EE": "Estija",
			"ET": "Etiopija",
			"FJ": "Fidžis",
			"GA": "Gabonas",
			"GM": "Gambija",
			"GH": "Gana",
			"GR": "Graikija",
			"GD": "Grenada",
			"GE": "Gruzija",
			"GT": "Gvatemala",
			"GN": "Gvinėja",
			"GW": "Bisau Gvinėja",
			"GY": "Gajana",
			"HT": "Haitis",
			"HN": "Hondūras",
			"HU": "Vengrija",
			"IS": "Islandija",
			"IN": "Indija",
			"ID": "Indonezija",
			"IR": "Iranas",
			"IQ": "Irakas",
			"IE": "Airija",
			"IL": "Izraelis",
			"IT": "Italija",
			"JM": "Jamaika",
			"JP": "Japonija",
			"JO": "Jordanija",
			"KH": "Kambodža",
			"CM": "Kamerūnas",
			"CA": "Kanada",
			"CN": "Kinija",
			"CO": "Kolumbija",
			"KM": "Komorai",
			"CG": "Kongo Respublika",
			"CD": "Kongo Demokratinė Respublika",
			"CR": "Kosta Rika",
			"HR": "Kroatija",
			"CU": "Kuba",
			"CY": "Kipras",
			"KZ": "Kazachstanas",
			"KE": "Kenija",
			"KI": "Kiribatis",
			"KP": "Šiaurės Korėja",
			"KR": "Pietų Korėja",
			"KW": "Kuveitas",
			"KG": "Kirgizija",
			"LA": "Laosas",
			"LV": "Latvija",
			"LB": "Libanas",
			"LS": "Lesotas",
			"LR": "Liberija",
			"LY": "Libija",
			"LI": "Lichtenšteinas",
			"LT": "Lietuva",
			"LU": "Liuksemburgas",
			"MK": "Makedonija",
			"MG": "Madagaskaras",
			"MW": "Malavis",
			"MY": "Malaizija",
			"MV": "Maldyvai",
			"ML": "Malis",
			"MT": "Malta",
			"MH": "Maršalo salos",
			"MR": "Mauritanija",
			"MU": "Mauricijus",
			"MX": "Meksika",
			"FM": "Mikronezija",
			"MD": "Moldavija",
			"MC": "Monakas",
			"MN": "Mongolija",
			"ME": "Juodkalnija",
			"MA": "Marokas",
			"MZ": "Mozambikas",
			"MM": "Mianmaras",
			"NA": "Namibija",
			"NR": "Nauru",
			"NP": "Nepalas",
			"NL": "Nyderlandai",
			"NZ": "Naujoji Zelandija",
			"NI": "Nikaragva",
			"NE": "Nigeris",
			"NG": "Nigerija",
			"NO": "Norvegija",
			"OM": "Omanas",
			"PK": "Pakistanas",
			"PW": "Palau",
			"PA": "Panama",
			"FR": "Prancūzija",
			"PG": "Papua Naujoji Gvinėja",
			"PY": "Paragvajus",
			"GQ": "Pusiaujo Gvinėja",
			"PE": "Peru",
			"PH": "Filipinai",
			"PL": "Lenkija",
			"PT": "Portugalija",
			"QA": "Kataras",
			"RO": "Rumunija",
			"RU": "Rusija",
			"RW": "Ruanda",
			"SV": "Salvadoras",
			"KN": "Sent Kitsas ir Nevis",
			"LC": "Sent Lusija",
			"VC": "Sent Vinsentas ir Grenadinai",
			"WS": "Samoa",
			"SM": "San Marinas",
			"ST": "San Tomė ir Prinsipė",
			"SA": "Saudo Arabija",
			"SN": "Senegalas",
			"RS": "Serbija",
			"SC": "Seišeliai",
			"SL": "Siera Leonė",
			"SG": "Singapūras",
			"FI": "Suomija",
			"SK": "Slovakija",
			"SI": "Slovėnija",
			"SB": "Saliamono Salos",
			"SO": "Somalis",
			"ZA": "PAR",
			"SS": "Pietų Sudanas",
			"ES": "Ispanija",
			"LK": "Šri Lanka",
			"SD": "Sudanas",
			"SR": "Surinamas",
			"SZ": "Svazilendas",
			"SE": "Švedija",
			"CH": "Šveicarija",
			"SY": "Sirija",
			"TJ": "Tadžikija",
			"TZ": "Tanzanija",
			"TH": "Tailandas",
			"TL": "Rytų Timoras",
			"TG": "Togas",
			"TO": "Tonga",
			"TT": "Trinidadas ir Tobagas",
			"TN": "Tunisas",
			"TR": "Turkija",
			"TM": "Turkmėnija",
			"TV": "Tuvalu",
			"UG": "Uganda",
			"UA": "Ukraina",
			"AE": "Jungtiniai Arabų Emyratai",
			"GB": "Jungtinė Karalystė",
			"US": "Jungtinės Valstijos",
			"UY": "Urugvajus",
			"UZ": "Uzbekistanas",
			"VU": "Vanuatu",
			"VE": "Venesuela",
			"DE": "Vokietija",
			"VN": "Vietnamas",
			"YE": "Jemenas",
			"ZM": "Zambija",
			"ZW": "Zimbabvė",
			"CV": "Žaliasis Kyšulys"
		}
	},

	callingCodes: ["1", "1242", "1246", "1264", "1268", "1284", "1340", "1345", "1441", "1473", "1649", "1664", "1670", "1671", "1684", "1721", "1758", "1767", "1784", "1787", "1809", "1829", "1849", "1868", "1869", "1876", "1939", "20", "211", "212", "213", "216", "218", "220", "221", "222", "223", "224", "225", "226", "227", "228", "229", "230", "231", "232", "233", "234", "235", "236", "237", "238", "239", "240", "241", "242", "243", "244", "245", "246", "247", "248", "249", "250", "251", "252", "253", "254", "255", "256", "257", "258", "260", "261", "262", "263", "264", "265", "266", "267", "268", "269", "27", "290", "291", "297", "298", "299", "30", "31", "32", "33", "34", "350", "351", "352", "353", "354", "355", "356", "357", "358", "359", "36", "370", "371", "372", "373", "374", "375", "376", "377", "378", "379", "380", "381", "382", "383", "385", "386", "387", "389", "39", "40", "41", "420", "421", "423", "43", "44", "45", "46", "47", "4779", "48", "49", "500", "501", "502", "503", "504", "505", "506", "507", "508", "509", "51", "52", "53", "54", "55", "56", "57", "58", "590", "591", "592", "593", "594", "595", "596", "597", "598", "599", "5999", "60", "61", "62", "63", "64", "65", "66", "670", "672", "673", "674", "675", "676", "677", "678", "679", "680", "681", "682", "683", "685", "686", "687", "688", "689", "690", "691", "692", "7", "81", "82", "84", "850", "852", "853", "855", "856", "86", "880", "886", "90", "91", "92", "93", "94", "95", "960", "961", "962", "963", "964", "965", "966", "967", "968", "970", "971", "972", "973", "974", "975", "976", "977", "98", "992", "993", "994", "995", "996", "998"],

	doNothing: function () {
	},

	init: function () {
		let header = document.getElementById('header-wrapper');
		if (header) {
			new D.StickyHeader(header);
		}

		D.initDropdownMenu();

		if (D.ID) {
			setInterval(function () {
				$.post('/keepalive.php');
			}, 600000);

			let get = new Get();
			if (get.is('auth')) {
				D.Analytics.branch('LOGIN', {
					"description": "Login from " + get.v('auth'),
					"user_id": D.ID
				});
			}
		}
	},

	loadingOverlay: function (node, par) {
		par = par || {};
		if (typeof node === 'string') {
			node = document.getElementById(node);
		}
		if (!node) {
			D.console.error('D.loadOverlay( node ) - not element');
			return false;
		}
		if (node._drOverlay) {
			node._drOverlay.remove();
		}
		if (getStyle(node, 'position') === 'static') {
			node.style.position = 'relative';
		}
		let overlay = node._drOverlay = mkE({
			tag: 'div',
			className: 'rqOverlay',
			style: {
				height: 'auto',
				width: 'auto',
				bottom: '0px',
				right: '0px'
			}
		}).append(node);
		if (par.delay) {
			addClassName(overlay, 'delay');
		}
		setTimeout(function () {
			addClassName(overlay, 'fadeIn');
		}, 1);
		if (par.loadingText) {
			setTimeout(D.closure(this, function () {
				if (node._drOverlay) {
					mkE({
						tag: 'div',
						className: 'rqLoadingText',
						text: par.loadingText
					}).append(overlay);
				}
			}), 2000);
		}
		if (par.backgroundPosition) {
			overlay.style.backgroundPosition = par.backgroundPosition;
		} else if (overlay.offsetHeight > 400) {
			overlay.style.backgroundAttachmentX = 'fixed';
		}
		setTimeout(function () {
			let q = $(overlay);
			if (!q.closest('body')[0]) {
				return;
			}
			q.animate({opacity: 0.9}, 6000);
		}, 2000);
		return overlay;
	},

	removeLoadingOverlay: function (node) {
		if (typeof node === 'string') {
			node = document.getElementById(node);
		}
		if (!node) {
			D.console.error('D.removeLoadOverlay( node ) - not element');
			return false;
		}
		if (node._drOverlay) {
			node._drOverlay.remove();
			return true;
		}
		return false;
	},

	position: function (el, parent) {
		let re = {
			left: findPosX(el, parent),
			top: findPosY(el, parent)
		};
		re.x = re.left + $(document).scrollLeft();
		re.y = re.top + $(document).scrollTop();
		return re;
	},

	rootDomain: function (url) {
		let a = url;
		try {
			if (url.nodeType !== Node.ELEMENT_NODE) {
				a = mkE({
					tag: 'a',
					href: url
				});
			}
			if (a.host.match(/^[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}$/)) {
				return a.host;
			}
			let parts = a.host.split('.');
			if (!parts[1]) {
				return a.host
			}
			parts.splice(0, parts.length - 2);
			return parts.join('.');
		} catch (e) {
			D.console.error(e);
		}
		return '';
	},

	/**
	 * @param {Event} e
	 * @return {Event}
	 */
	event: function (e) {
		e = e || window.event;
		if (!e) {
			return e;
		}
		if (typeof e.layerX === 'undefined') {
			e.layerX = e.offsetX;
			e.layerY = e.offsetY;
		}
		if (typeof e.target === 'undefined') {
			e.target = e.srcElement;
		}
		return e;
	},

	url: function (url, lang, full) {
		let parts = url.split('?', 2);
		url = parts[0].replace(/^\/+|\/+$/g, '');
		let urlParts = url.split('/');
		let currentLang = reset(urlParts);
		if (!in_array(currentLang, D.LANGS)) {
			currentLang = D.LANG;
		} else {
			urlParts.shift();
		}
		currentLang = lang || currentLang;
		let re = (full === true ? D.URL : '/') + currentLang;
		if (urlParts.join('/')) {
			re += '/' + urlParts.join('/');
		}
		if (D.APP_WEBVIEW && parts[1]) {
			parts[1] = 'app-webview&' + parts[1];
		} else if (D.APP_WEBVIEW) {
			parts[1] = 'app-webview';
		}
		return re + (parts[1] ? '?' + parts[1] : '');
	},

	/**
	 * @param {string} src
	 * @param {Function} [callback]
	 * @param {Object} [par]
	 * @returns {boolean}
	 */
	addJS: function (src, callback, par) {
		callback = callback || false;
		par = par || {};
		par.context = par.context || document;
		par.async = (isset(par.async) ? par.async : true);
		var head = getHeadElement(par.context);
		var differentOrigin = false;
		var path = function () {
			if ((src[0] == '/' && src[1] == '/') || src[4] == ':' || src[5] == ':') {
				return src;
			}
			if (src[0] == '/') {
				src = src.substr(1);
			}
			differentOrigin = !D.DEV;
			if (D.DEV) {
				return '/' + src;
			}
			return '/' + src;
		};
		var s = path();
		var scripts = head.getElementsByTagName('script');
		for (var i = 0; i < scripts.length; ++i) {
			if (!scripts[i].src) {
				continue;
			}
			var ix = scripts[i].src.indexOf(s);
			if (ix == -1) {
				continue;
			}
			if (scripts[i].src.length == ix + s.length) {
				if (callback && typeof (callback) === 'function') {
					callback();
				}
				return false;
			}
		}
		var prop = {};
		if (typeof (callback) === 'function') {
			var ready = false;
			prop.onload = prop.onreadystatechange = function () {
				if (!ready && (!this.readyState ||
					this.readyState === 'loaded' || this.readyState === 'complete')) {
					ready = true;
					callback();
					this.onload = null;
					this.onreadystatechange = null;
				}
			};
		}
		let attr = {
			type: 'text/javascript',
			charset: 'utf-8',
			src: s,
			async: par.async
		};
		if (differentOrigin) {
			attr.crossorigin = 'anonymous';
		}
		mkE({
			tag: 'script',
			attr: attr,
			prop: prop
		}).append(head);

		return true;
	},

	/**
	 * @param {string} src
	 * @param {Function} [callback]
	 * @param {Object} [par]
	 */
	addCSS: function (src, callback, par) {
		callback = callback || false;
		par = par || {};
		par.context = par.context || document;
		var head = getHeadElement(par.context);
		var path = function () {
			if ((src[0] == '/' && src[1] == '/') || src[4] == ':' || src[5] == ':') {
				return src;
			}
			if (src[0] == '/') {
				src = src.substr(1);
			}
			return '/' + src;
		};
		var s = path();
		var links = head.getElementsByTagName('link');
		for (var i = 0; i < links.length; ++i) {
			var link = links[i];
			if (link.type == 'text/css' && link.href.indexOf(s) == 0) {
				if (callback && typeof (callback) === 'function') {
					callback();
				}
				return;
			}
		}
		var prop = {};
		if (typeof (callback) === 'function') {
			var ready = false;
			prop.onload = prop.onreadystatechange = function () {
				if (!ready && (!this.readyState ||
					this.readyState === 'loaded' || this.readyState === 'complete')) {
					ready = true;
					callback();
					this.onload = null;
					this.onreadystatechange = null;
				}
			};
		}
		mkE({
			tag: 'link',
			attr: {
				type: 'text/css',
				rel: 'stylesheet',
				href: s
			},
			prop: prop
		}).append(head);
	},

	reload: function (noParent) {
		var doc;
		if (window.parent && window.parent !== window && noParent !== true) {
			doc = window.parent.document;
		} else {
			doc = document;
		}
		doc.location.reload();
		return false;
	},

	/**
	 * @param {Node} node
	 * @param {RegExp} pattern
	 * @param {function} callback
	 * @param {Object} [par]
	 */
	replaceWithNode: function (node, pattern, callback, par) {
		par = par || {};
		if (!pattern.global) {
			D.console.error(pattern, ' require global RegExp');
			return;
		}
		if (node.nodeType == Node.ELEMENT_NODE) {
			var childs = [];
			for (var i = 0; i < node.childNodes.length; ++i) {
				childs.push(node.childNodes[i]);
			}
			for (var i = 0; i < childs.length; ++i) {
				if (childs[i].nodeType == Node.ELEMENT_NODE && par.ignoreLinks && childs[i].tagName == 'A') {
					continue;
				}
				this.replaceWithNode(childs[i], pattern, callback, par);
			}
			return;
		}
		if (node.nodeType != Node.TEXT_NODE) {
			return;
		}

		var match = false;
		var text = node.nodeValue;
		pattern.lastIndex = 0;
		var ta = [];
		var start = 0;
		var m;
		while ((m = pattern.exec(text)) !== null) {
			var sub = text.substr(start, pattern.lastIndex - start - m[0].length);
			ta.push(sub);
			start = pattern.lastIndex;
			ta.push(callback(m));
			match = true;
		}
		var sub = text.substr(start, text.length - start);
		ta.push(sub);
		if (!match) {
			return;
		}
		for (var i = 0; i < ta.length; ++i) {
			var v = ta[i];
			if (!v) {
				continue;
			}
			this._replaceInsertBefore(v, node);
		}
		removeNode(node);
	},

	_replaceInsertBefore: function (el, before) {
		if (typeof el == 'string') {
			var textNode = document.createTextNode(el);
			D.insertBefore(textNode, before);
			return;
		}
		if (is_array(el)) {
			for (var i = 0, l = el.length; i < l; i++) {
				var v = el[i];
				if (!v) {
					continue;
				}
				this._replaceInsertBefore(v, before);
			}
			return;
		}
		D.insertBefore(el, before);
	},

	stopPropagation: function (e) {
		e = e || window.event;
		if (!e) {
			return e;
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.cancelBubble = true;
		return e;
	},

	enableCookies: function (callback) {
		new RPC('/api/web_rpc.php').send('enableCookies', {}, function (re) {
			if (!callback) {
				D._onCookiesChange(re);
				return;
			}
			let cookiePrompt = document.getElementById('cookies-overlay');
			if (cookiePrompt) {
				removeNode(cookiePrompt);
			}
			callback();
		});
	},

	disableCookies: function (callback) {
		new RPC('/api/web_rpc.php').send('disableCookies', {}, D.closure(this, this._onCookiesChange, callback));
	},

	cookiesSettings: function (callback) {
		D._cookies = {
			popup: null,
			checkboxes: {}
		};
		D._cookies.popup = new T.Popup({
			className: 'popup-cookies cookies-popup'
		});
		D._cookies.popup.setTitle(mkE({
			tag: 'div',
			className: 'cookies-popup-title',
			text: D.Lang.get('home.cookies.title')
		}));
		D._cookies.popup.setContent(mkE({
			tag: 'div',
			className: 'cookies-popup-window',
			els: [
				{
					tag: 'p',
					className: 'cookies-popup-description',
					text: D.Lang.get('home.cookies.description')
				},
				{
					tag: 'div',
					className: 'cookies-popup-items',
					els: [
						{
							tag: 'div',
							className: 'cookies-popup-item',
							els: [
								new T.Form.CheckBox({
									checked: true,
									disabled: true,
									caption: mkE({
										tag: 'span',
										text: D.Lang.get('home.cookies.boxes.mandatory.title')
									})
								}),
								{
									tag: 'p',
									text: D.Lang.get('home.cookies.boxes.mandatory.description')
								}
							]
						},
						{
							tag: 'div',
							className: 'cookies-popup-item',
							els: [
								D._cookies.checkboxes.statistics = new T.Form.CheckBox({
									checked: D.COOKIES.statistics,
									caption: mkE({
										tag: 'span',
										text: D.Lang.get('home.cookies.boxes.statistics.title')
									})
								}),
								{
									tag: 'p',
									text: D.Lang.get('home.cookies.boxes.statistics.description')
								}
							]
						},
						{
							tag: 'div',
							className: 'cookies-popup-item',
							els: [
								D._cookies.checkboxes.marketing = new T.Form.CheckBox({
									checked: D.COOKIES.marketing,
									caption: mkE({
										tag: 'span',
										text: D.Lang.get('home.cookies.boxes.marketing.title')
									})
								}),
								{
									tag: 'p',
									text: D.Lang.get('home.cookies.boxes.marketing.description')
								}
							]
						}
					]
				},
				{
					tag: 'div',
					className: 'cookies-popup-bottom',
					els: [
						{
							tag: 'a',
							href: D.url('/cookies-policy'),
							target: '_blank',
							text: D.Lang.get('home.cookies.policy')
						},
						{
							tag: 'button',
							className: 'button button-pink button-large',
							onclick: D.closure(this, D.saveCookies, callback),
							text: D.Lang.get('home.cookies.save')
						}
					]
				}
			]
		}));
		D._cookies.popup.open();
	},

	saveCookies: function (callback) {
		let data = {};
		for (let type in D._cookies.checkboxes) {
			if (!D._cookies.checkboxes.hasOwnProperty(type)) {
				return;
			}
			D.COOKIES[type] = data[type] = D._cookies.checkboxes[type].value();
		}
		new RPC('/api/web_rpc.php').send('saveCookies', data, re => {
			if (!callback) {
				D._onCookiesChange(re);
				return;
			}
			if (D._cookies && D._cookies.popup) {
				D._cookies.popup.close();
			}
			let cookiePrompt = document.getElementById('cookies-overlay');
			if (cookiePrompt) {
				removeNode(cookiePrompt);
			}
			callback(data);
		});
	},

	_onCookiesChange: function () {
		if (D._cookies && D._cookies.popup) {
			D._cookies.popup.close();
		}
		removeNode(document.getElementById('cookies-overlay'));
		D.reload();
	},

	cookieConsent: function (type, value) {
		if (D.COOKIES[type]) {
			return value;
		}
		let node;
		node = mkE({
			tag: 'div',
			className: 'cookie-consent-iframe',
			els: [
				{
					tag: 'div',
					className: 'content',
					els: [
						{
							tag: 'p',
							text: D.Lang.get('home.cookies.consent.' + type)
						},
						{
							tag: 'div',
							className: 'bottom',
							els: [
								{
									tag: 'button',
									className: 'button button-gray',
									onclick: () => {
										D.enableCookies(() => {
											D.insertBefore(value, node);
											removeNode(node);
										});
									},
									text: D.Lang.get('home.cookies.consent.agree')
								},
								{
									tag: 'a',
									onclick: () => {
										D.cookiesSettings(data => {
											if (data.marketing) {
												D.insertBefore(value, node);
												removeNode(node);
											}
										});
									},
									text: D.Lang.get('home.cookies.consent.settings')
								}
							]
						}
					]
				}
			]
		});
		return node;
	},

	scrollIntoView: function (node, scrollParent, offset) {
		let top;
		if (!isset(offset)) {
			offset = 70;
		}
		if (scrollParent) {
			top = D.position(node, scrollParent).top - offset;
			$(scrollParent).animate({
				scrollTop: top
			});
		}
		top = D.position(node).top - offset;
		$('html, body').animate({
			scrollTop: top
		});
	},

	initDropdownMenu: function () {
		let el = document.querySelector('.main-menu-account');
		if (el) {
			el.addEventListener('mouseover', D.closure(this, D.onDropdownOver, '.main-menu-account', 'bottom'));
			el.addEventListener('mouseout', D.closure(this, D.onDropdownOut, '.main-menu-account'));
		}

		let el2 = document.querySelector('.main-menu-language');
		if (el2) {
			el2.addEventListener('mouseover', D.closure(this, D.onDropdownOver, '.main-menu-language', 'bottom'));
			el2.addEventListener('mouseout', D.closure(this, D.onDropdownOut, '.main-menu-language'));
		}

		let el3 = document.querySelector('.main-menu-corporate');
		if (el3) {
			el3.addEventListener('mouseover', D.closure(this, D.onDropdownOver, '.main-menu-corporate', 'bottom'));
			el3.addEventListener('mouseout', D.closure(this, D.onDropdownOut, '.main-menu-corporate'));
		}
	},

	onDropdownOver: function (selector, position) {
		let windowSize = $(window).width() / parseFloat($("body").css("font-size"));
		if (windowSize < 992 / 14) {
			return;
		}
		let el = document.querySelector(selector);
		if (!el) {
			return;
		}
		let dropdown = document.querySelector(selector + ' > div');
		if (!dropdown) {
			return;
		}
		addClassName(dropdown, 'active');
		el._popper = new Popper(el, dropdown, {
			placement: position
		});
	},

	onDropdownOut: function (selector) {
		let el = document.querySelector(selector);
		if (!el) {
			return;
		}
		let dropdown = document.querySelector(selector + ' > div');
		if (!dropdown) {
			return;
		}
		removeClassName(dropdown, 'active');
		if (el._popper) {
			el._popper.destroy();
		}
	},

	inScreen: function (el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.height > 0 &&
			rect.width > 0 &&
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	},

	addStats: function (kw) {
		let m = new DR.web.AddStats();
		m.kw = kw;
		m.call();
	},

	CSS: {
		brMobile: false,
		brTablet: false,
		onResize() {
			this.brMobile = screen.width < 768;
			this.brTablet = screen.width < 992;
		}
	},

	async loadGoogleMaps(libraries) {
		if (typeof google === "undefined" || typeof google.maps === "undefined") {
			(g => {
				let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__",
					m = document, b = window;
				b = b[c] || (b[c] = {});
				let d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams,
					u = () => h || (h = new Promise(async (f, n) => {
						await (a = m.createElement("script"));
						e.set("libraries", [...r] + "");
						for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);
						e.set("callback", c + ".maps." + q);
						a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
						d[q] = f;
						a.onerror = () => h = n(Error(p + " could not load."));
						a.nonce = m.querySelector("script[nonce]")?.nonce || "";
						m.head.append(a)
					}));
				d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n))
			})({
				key: "AIzaSyAq5TPvce-Ornjbe71qIDVN7YsOWQjNVzk",
				v: "weekly"
			});
		}
		await google.maps.importLibrary('maps');
		if (libraries && libraries.length) {
			for (let i = 0; i < libraries.length; i++) {
				await google.maps.importLibrary(libraries[i]);
			}
		}
	},

	lottie(par) {
		return new Promise(function(resolve, reject) {
			D.addJS('/dist/vendor/lottie/lottie.min.js?v=' + D.v, function() {
				resolve(lottie.loadAnimation(par));
			});
		});
	},

	lottieEl(par, options) {
		let el = mkE(par);
		options.container = el;
		this.lottie(options);
		return el;
	},

	MAP_STYLE: [
		{
			"featureType": "landscape.man_made",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f9f5ed"
				},
				{
					"saturation": "0"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f9f5ed"
				}
			]
		},
		{
			"featureType": "landscape.natural.terrain",
			"elementType": "geometry",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi.attraction",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi.business",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi.medical",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#fbd3da"
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#dbeed0"
				}
			]
		},
		{
			"featureType": "poi.sports_complex",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#fcfcdd"
				},
				{
					"saturation": "0"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#efd151"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#ffffff"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#dcdcdc"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"color": "#ffffff"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"color": "#d4cdb9"
				}
			]
		},
		{
			"featureType": "transit.station.airport",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#e1e6ea"
				}
			]
		},
		{
			"featureType": "transit.station.airport",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#b5c5d2"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#a2daf2"
				}
			]
		}
	]

};

D.JSON = window._DJSON;
